import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
const styles = theme => ({})
class DeleteModal extends React.Component {
  static propTypes = {
    items: PropTypes.array,
    deleteAction: PropTypes.func,
    hideModal: PropTypes.func
  }

  handleDelete = () => {
    const { items } = this.props
    this.props.deleteAction(items.length === 1 ? items[0] : items)
  }
  componentDidMount() {}
  render() {
    const { items } = this.props
    const item = items.length === 1 ? items[0] : void 0
    return (
      <ModalWrapper
        open
        hideModal={this.props.hideModal}
        onOk={this.handleDelete}
        maxWidth={'xs'}
        title={`Supprimer ${item ? item.name : ''}`}
        okText="Supprimer"
        okDisabled={false}>
        <Grid container direction="column" justify="center">
          <Grid item xs={12}>
            <Typography variant="subheading" gutterBottom>
              {!item
                ? `Êtes-vous sur de vouloir supprimer les éléments suivants ?`
                : `Êtes-vous sur de vouloir supprimer cet élément ?`}
              <Typography variant="caption">
                Cette action est irréversible
              </Typography>
            </Typography>
            {!item
              ? items.map((i, index) => (
                  <Typography key={index} gutterBottom>
                    {`- ${i.name}`} <br />{' '}
                  </Typography>
                ))
              : null}
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(DeleteModal)



// WEBPACK FOOTER //
// ./src/components/modals/common/DeleteModal.js